import React from "react";
import "./LoadingError.css";

const LoadingError = ({ retryFunc, errorText, className = "" }) => {
  return (
    <div className={`loadingerror__error ${className}`}>
      <div className="loadingerror__notification">
        <img
          src="https://hrgo.spacebetween.co.uk/images/icons/timesheet-error.svg"
          alt="loadingerror-failed"
        />
        <h2 className="loadingerror__notification-title">Loading failed</h2>
        <span className="loadingerror__errorMessage">{errorText}</span>
        <span className="loadingerror__errorMessage">
          Please click on the button below to retry.
        </span>
        <button className="btn btn-primary mx-1 my-1" onClick={retryFunc}>
          Try again
        </button>
      </div>
    </div>
  );
};

export default LoadingError;
